import React, { Component } from "react";
import Grid from "@material-ui/core/Grid";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <Grid container justifyContent="center">
          <Grid item>{this.props.children}</Grid>
        </Grid>
      </footer>
    );
  }
}

export default Footer;
